Collection = require('./collection')
Model = require('./Model').default

module.exports = class Field extends Model

    defaults:
        # previously anonymous attributes
        value: null



// WEBPACK FOOTER //
// ./app/models/Field.coffee